<template>
    <div v-if="isPermission">
        <view-analytics-header />
        <div 
            :class="{
                'layout-analytics__container': $route.name !== 'analyticsSummary',
                'layout-analytics-summary__container' : $route.name === 'analyticsSummary'
            }"
        >
            <router-view />
        </div>
    </div>
    <div v-else>
        У вас нет прав на доступ к рабочему столу
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ViewAnalyticsHeader from '../views/ViewAnalytics/ViewAnalyticsHeader';
import serviceAuth from '../services/serviceAuth';
export default {
    name: 'LayoutAnalytics',
    components: {
        ViewAnalyticsHeader
    },
    /**
     * данные компонента
     * @property {boolean} isPermission - право на показ
     */
    data: () => ({
        isPermission: false
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    mounted() {
        // console.log(this.$route.name);
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Рабочий стол");
        // получаем право на отображение
        this.isPermission = serviceAuth.checkPermission(this.activeProjectId, 'view_analytics');
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ])
    }
}
</script>

<style lang="scss" scoped>
    .layout-analytics__container {
        // margin-top: 10px;
        // padding: 20px 25px;
        // background: #fff;
        // border-radius: 14px;
        flex: 1;
    }
    .layout-analytics-summary__container {
        margin-top: 10px;
        /*padding: 20px 25px;*/
        /*border-radius: 14px;*/
        flex: 1;
    }
    ::v-deep .view-analytics__table-container {   
        margin-top: 30px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
    }
    ::v-deep .view-analytics__table-title {
        font-size: 20px;
        margin-bottom: 20px;
        font-weight: bold;
    }
</style>